<mat-card class="module-card d-flex flex-column h-100 p-3 gap-2">
    <div class="d-flex flex-row gap-2 align-items-start">
        <div class="icon-container">
            <mat-icon class="module-icon">{{ module.imagen_url || 'home' }}</mat-icon>
        </div>

        <div class="flex-grow-1 d-flex flex-column justify-content-between">
            <h5 class="m-0" [appTruncate]="15" [appTruncateText]="module.descripcion_modulo">{{ module.descripcion_modulo }}</h5>

            <p class="text-muted mb-1 description">
                {{ capitalize(module.descripcion_larga) || 'Descripción del módulo' }}
            </p>

            <div class="d-flex justify-content-end">
                <button color="primary" class="btn-more">
                    <a>Ver más</a>
                </button>
            </div>

        </div>
    </div>
</mat-card>
